import bemBlock from "@gik/core/utils/bemBlock";
import { testimonials } from "@gik/marketing/testimonials";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import { TestimonialsCarousel } from "@gik/ui-legacy/gik/TestimonialsCarousel";
import React from "react";

function TestimonialsCarouselSectionComp(): React.ReactElement {
	const bem = bemBlock("testimonials-carousel-section");
	return (
		<PageSection className={bem()}>
			<TestimonialsCarousel variant="secondary" items={testimonials} />
		</PageSection>
	);
}

export const TestimonialsCarouselSection = React.memo(
	TestimonialsCarouselSectionComp,
);
